const ITEMS = [
  "Casas prontas para morar",
  "Apartamentos de alto padrão",
  "Qualidade construtiva",
  "Atenção aos detalhes",
  "Casa Vale Engenharia",
];

export default function Marquee() {
  const content = [...ITEMS, ...ITEMS];
  return (
    <div className="bg-slate-900 py-5 overflow-hidden" aria-hidden="true" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {content.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif italic text-lg md:text-xl text-white/90 whitespace-nowrap px-8">{item}</span>
                <span className="w-2 h-2 rotate-45 bg-limebrand inline-block" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
